<template>
  <v-list :two-line="true">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title v-text="$t('monitoring.info.process')" />
        <v-list-item-subtitle v-text="process.processType" />
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title :style="{ color }">
          {{ $t('monitoring.status') }}
          <v-icon :color="color" v-html="icon" />
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title v-text="$t('monitoring.info.start_date')" />
        <v-list-item-subtitle v-text="process.startDateTime" />
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title v-text="$t('monitoring.info.end_date')" />
        <v-list-item-subtitle v-text="process.endDateTime" />
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-btn color="primary" v-text="$t('monitoring.details.copy_link')" @click="copyURL" />
    </v-list-item>
    <v-list-item>
      <RefreshButton @click="$emit('refresh')" />
    </v-list-item>
    <v-list-item>
      <GoBackButton />
    </v-list-item>
  </v-list>
</template>
<script>
import Utils from '../../utils'
import GoBackButton from '../GoBackButton.vue'
import RefreshButton from '../RefreshButton.vue'
import colors from 'vuetify/lib/util/colors'

export default {
  name: 'Info',

  components: { GoBackButton, RefreshButton },

  props: {
    process: {
      type: Object,
      required: true
    }
  },

  computed: {
    color () { return Utils.getStatusColor(this.process.status) },
    icon () { return Utils.getStatusIcon(this.process.status) }
  },

  methods: {
    copyURL () {
      const actualURL = window.location.href
      navigator.clipboard.writeText(actualURL)
    }
  },

  mounted () {
    console.debug(colors)
  }
}
</script>
